import { render } from "./MainSectionHeading.vue?vue&type=template&id=59dc5bda&scoped=true"
import script from "./MainSectionHeading.vue?vue&type=script&lang=js"
export * from "./MainSectionHeading.vue?vue&type=script&lang=js"

import "./MainSectionHeading.vue?vue&type=style&index=0&id=59dc5bda&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\market\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59dc5bda"]])

export default __exports__